import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ShowCommunityPage = () => {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const handleActionClick = (key: string): void => {
    if (!id) return

    switch (key) {
      case 'write-post':
        navigate(navigation.dashboard.post.new.fullPath())
        break
      case 'join-group':
        navigate(navigation.dashboard.groups.join.fullPath())
        break
      case 'edit-community':
        navigate(navigation.dashboard.groups.id.edit.fullPath({ id }))
        break
      case 'add-members':
        navigate(navigation.dashboard.groups.id.addMembers.fullPath({ id }))
        break
      case 'remove-members':
        navigate(navigation.dashboard.groups.id.removeMembers.fullPath({ id }))
        break
      case 'leave-group':
        navigate(navigation.dashboard.groups.id.leave.fullPath({ id }))
        break
      case 'delete-community':
        navigate(navigation.dashboard.groups.id.delete.fullPath({ id }))
        break
    }
  }

  if (!id) {
    return null
  }

  return (
    <ResponsivePage.Body onActionClick={handleActionClick}>
      <Box maxWidth="s600" alignSelf="center">
        {/* // TODO: Add community posts list here */}
      </Box>
    </ResponsivePage.Body>
  )
}

export default ShowCommunityPage
